import apiClient from './apiClient';

export const updateBrand = (brandId, payload) => apiClient.put(`/brands/${brandId}/`, payload).then(r => r.data);
